<template>
  <sTooltip
    :open-delay="200"
    placement="bottom"
    transition="s-zoom-in-top">
    <div
      v-if="with_photo"
      class="creator flex pa-0 mr-1">
      <UserIcon
        class="py-0 mr-2"
        :name="name_text"
        size="28"
        :src="avatar_icon"/>
      <span
        class="text-decoration-underline">
        {{ item_name || name || $t('Common.NoData') }}
      </span>
    </div>
    <span
      v-else
      class="text-decoration-underline">
      {{ item_name || name || $t('Common.NoData') }}
    </span>
    <div
      slot="content"
      class="align-center flex"
      no-gutters>
      <UserIcon
        class="mr-2"
        :name="name_text"
        size="38"
        :src="avatar_icon"/>
      <div
        v-if="name_text || department_text"
        class="text-start">
        <span
          v-if="name_text"
          class="black--text">
          {{ name_text || '–' }}
        </span>
        <div
          v-if="department_text"
          class="subheader">
          {{ department_text }}
        </div>
      </div>
    </div>
  </sTooltip>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'

export default {
  name: 'personTooltip',
  props: {
    item: Object,
    name: String,
    with_photo: Boolean,
    department: Object,
    avatar: String
  },
  computed: {
    item_name() {
      if (!this.item) { return '' }
      let id = (this.item.user?.userId && this.item.user?.userId == this.userId)
        || (this.item.id && this.item.id == this.userId)
        || (this.item.contactId && this.item.contactId == this.contactId )
        || (this.item.userId && this.item.userId == this.userId)
        || this.item.isMy
      return id ? this.$t('Common.You') : this.item.fullName
    },
    user() {
      return this.$store.getters['GET_USER']
    },
    userId() {
      return this.user?.purchasingSettings?.userId
    },
    contactId() {
      return this.user?.tenderSettings?.contactId
    },
    department_text() {
      return this.department?.name || this.item?.department?.name || '–'
    },
    name_text() {
      return this.name || this.item?.fullName
    },
    avatar_icon() {
      return this.avatar || this.item?.avatar || ''
    }
  },
  components: {
    UserIcon,
  }
}
</script>
<style lang="scss" scoped>
.creator {
  span {
    height: 20px;
  }
}
.persone-name {
  display: contents;
}
</style>
